import { useCallback, useContext } from "react";

import type { ClearReferrerCallback, RefreshSearchSessionIdCallback, SetQueryParamsCallback } from "../../../../../common/constants/bootstrap";
import { areAllEqualQueryParams, parseQueryParams, toQueryParamsRaw } from "../../../../../common/utils/query-params";
import { DynamicBootstrapContext, StaticBootstrapContext } from '../index';

// TODO QS-8575: (within the Bootstrap rss removal) This hook should be localised to the top of the render tree and passed down as a prop, with queryParams provided as an attribute. Currently whenever queryParams change, this will force a context search of the whole tree
export const useSetQueryParamsContext = (): SetQueryParamsCallback => {
	const { queryParams: currentQueryParams } = useContext(DynamicBootstrapContext);
	const { queryParamsCallback: hostProductSetQueryParamsCallback } = useContext(StaticBootstrapContext);

	const setQueryParamsCallback: SetQueryParamsCallback = useCallback(newParams => {

		// Performance optiomisation: don't do any work if the new param won't lead to a param change
		const areEqualQueryParams = areAllEqualQueryParams(
			newParams,
			parseQueryParams(currentQueryParams ?? {}),
		);
		if (areEqualQueryParams) {
			return;
		}

		// Transform into the raw format expected by the host product callback
		const rawQueryParams = toQueryParamsRaw(newParams);

		// Call the host product callback to update the URL with the new query params
		hostProductSetQueryParamsCallback(rawQueryParams);
	}, [currentQueryParams, hostProductSetQueryParamsCallback]);

	return setQueryParamsCallback;
};

export const useRefreshSearchSessionIdContext = (): RefreshSearchSessionIdCallback => {
	const { refreshSearchSessionId } = useContext(StaticBootstrapContext);
	return refreshSearchSessionId;
};

export const useClearReferrerContext = (): ClearReferrerCallback => {
	const { clearReferrer } = useContext(StaticBootstrapContext);
	return clearReferrer;
};
